// Features that need a parent are not available to a student who signed up on
// their own (student-self-signup-prd.md Q4 Hangar). Learn shows this reason
// instead of a dead entry point. Challenges are no longer here: since
// 2026-10-10 (D-SSU-23, Q5 reversed) the student enters and signs for themselves. Adding a parent is optional and
// lives only in My profile (Phase 2 ParentLinkCard, §2.3: "do not nag"), so
// this notice carries no action. After a parent link the gates pass.

export type ParentNeededFeature = 'hangar';

const COPY: Record<ParentNeededFeature, { title: string; body: string }> = {
  hangar: {
    title: 'Airbotix Hangar needs a parent',
    body: 'A parent pairs the computer before Hangar’s AI helper works. Student accounts without a parent cannot use Hangar yet.',
  },
};

export function ParentNeededNotice({
  feature,
  className = '',
}: {
  feature: ParentNeededFeature;
  className?: string;
}) {
  const { title, body } = COPY[feature];
  return (
    <div
      className={`rounded-3xl border border-hairline bg-surface p-5 ${className}`}
      data-testid={`parent-needed-${feature}`}
    >
      <span className="sticker-sunshine">Needs a parent</span>
      <h2 className="mt-3 text-lg font-bold text-ink">{title}</h2>
      <p className="mt-1 text-[14px] text-ink-soft">{body}</p>
    </div>
  );
}
